import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';

const InitialModal = () => {
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    document.querySelector('.restart').focus();
  };

  useEffect(() => {
      disabledTabMoveButton(['initial_btn','ri-close-line restart']);
      disabledTabMoveInput();
  }, [])

  return (
    <div className="initial_bg">
      <div className="modal_area">
        <button  type='button' className="ri-close-line restart" onClick={closeModal} aria-label='닫기'/>
        <div className="alert_box">대화내용이 초기화 됩니다.</div>
        <button
          type='button'
          className="initial_btn"
          onClick={() => {
            dispatch(disableAllMenu());
            fallbackTabMove();
            window.location.reload();
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default InitialModal;
